import React, { createContext, useContext, useMemo } from 'react';
import { StopGeneratingGuardProvider } from '../hooks/use-stop-generating-guard';
const AltTextScreenContext = /*#__PURE__*/createContext(null);
export const useSharedAltTextScreenContext = () => {
  const context = useContext(AltTextScreenContext);
  if (!context) {
    throw new Error('useSharedAltTextScreenContext must be used within an AltTextScreenProvider. ' + 'Make sure to wrap your alt-text screen components with <AltTextScreenProvider>.');
  }
  return context;
};
export const AltTextScreenProvider = _ref => {
  let {
    value,
    children
  } = _ref;
  const memoizedValue = useMemo(() => value, [value]);
  return /*#__PURE__*/React.createElement(AltTextScreenContext.Provider, {
    value: memoizedValue
  }, /*#__PURE__*/React.createElement(StopGeneratingGuardProvider, null, children));
};
//# sourceMappingURL=alt-text-screen-context.js.map